import React from "react";
import { motion } from "framer-motion";
import Button from "../../../components/ui/Button";
import { FaArrowRight } from "react-icons/fa6";

const Cta: React.FC = () => {
  const handleRequestDemo = () => {
    window.open(
      "https://cal.com/seamlessvisa/consultation",
      "_blank",
    );
  };

  return (
    <section className="py-24 px-6 lg:px-8 bg-white overflow-hidden">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="mx-auto max-w-7xl bg-blue-02 rounded-[3rem] p-12 md:p-24 relative overflow-hidden text-center"
      >
        {/* Decorative elements */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-blue-00/10 rounded-full -translate-y-1/2 translate-x-1/2 blur-3xl pointer-events-none" />
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-blue-ea/5 rounded-full translate-y-1/2 -translate-x-1/2 blur-3xl pointer-events-none" />

        <div className="relative z-10 text-center flex flex-col items-center">
          <h2 className="text-4xl md:text-6xl font-bold font-spartan text-white leading-tight mb-8">
            Ready to{" "}
            <span className="text-blue-00 italic mx-1">🚀 scale</span>{" "}
            your <br />
            immigration{" "}
            <span className="text-purple-600 italic mx-1">💼 business?</span>
          </h2>
          <p className="text-blue-ea/80 text-xl font-inter max-w-2xl mx-auto mb-12">
            Join hundreds of forward-thinking businesses using SeamlessVisa to
            streamline their global workforce management.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
            <Button
              label="Request A Free Demo"
              onClick={handleRequestDemo}
              variant="primary"
              size="large"
              endIcon={<FaArrowRight />}
            />
          </div>

          <p className="mt-8 text-blue-ea/40 text-sm font-medium tracking-wide uppercase">
            No credit card required • Unlimited free trials
          </p>
        </div>
      </motion.div>
    </section>
  );
};

export default Cta;
